import Colors from "@constants/Colors";
import Users from "@icons/Users";
import Vector from "@icons/Vector";
import { GlobalStyles } from "@mui/material";
import ParentCard from "@shared-layouts/ParentCard";
import { useNavigate } from "react-router-dom";

import DollarSign from "@icons/DollarSign";
import PieChart from "@icons/PieChart";
import TextFile from "@icons/TextFile";
import useShowPropertyType from "@hooks/useShowPropertyType";
import { formatWithPercentage } from "@src/constants";
import CurrentProgress from "./CurrentTarget";
import TotalSalesSharedCard from "./TotalSalesSharedCard";
import { geStilePercaptListData } from "./helper";
import {
  CurrentProgressMainWrapper,
  TotalCardWrapper,
  TotalSalesSharedCardWrapper,
} from "./style";

const TotalSales = (props: {
  filter: number;
  cardData: dashboardDataTypes;
  loading: boolean;
}) => {
  const { filter, cardData, loading } = props;
  const hideStilePerCap = useShowPropertyType(filter, "hideStilePerCap");
  const hideGuestData = useShowPropertyType(filter, "hideGuestData");
  const hideGrossMargin = useShowPropertyType(filter, "hideGrossMargin");
  const isQsPropertyStore = useShowPropertyType(filter, "isQsPropertyStore");

  const propertyRestaurantCateringRevenueCenters = useShowPropertyType(
    filter,
    "propertyRestaurantCateringRevenueCenters"
  );
  const navigate = useNavigate();
  const mapListData = geStilePercaptListData({
    mapData: cardData?.stile,
    isPerCap: false,
    hideGross: isQsPropertyStore,
  });

  const listDataPerCap = geStilePercaptListData({
    mapData: cardData?.perCap,
    isPerCap: true,
    hideGross: isQsPropertyStore,
  });

  const Transactions = {
    title: "Transactions",
    list: cardData?.listTransactions,
    icon: <DollarSign color={Colors.primary} />,
  };

  const Compression = {
    title: "Compression",
    list: [
      {
        title: "%",
        value:
          cardData?.compression && formatWithPercentage(cardData?.compression),
      },
    ],
    icon: <TextFile color={Colors.primary} />,
  };

  const GuestCount = {
    title: "Guest Count",
    list: cardData?.listGuestCount,
    icon: <Users color={Colors.primary} />,
  };

  const grossMargin = {
    title: "Gross Margin",
    list: cardData?.listGrossMargin,
    icon: <PieChart color={Colors.primary} />,
  };

  const stylePerCapList = [
    {
      title: "Stile",
      list: mapListData,
      icon: <Users color={Colors.primary} />,
    },
    {
      title: "Per Cap",
      list: listDataPerCap,
      icon: <Vector color={Colors.primary} />,
    },
  ];

  let dataList: MapDataListType[] = [Transactions];

  if (!hideStilePerCap) {
    dataList = [...stylePerCapList, ...dataList];
  }

  if (!hideGuestData) {
    dataList = [GuestCount, ...dataList];
  }

  if (!hideGrossMargin) {
    dataList = [...dataList, grossMargin];
  }

  if (propertyRestaurantCateringRevenueCenters) {
    dataList = [...dataList, Compression];
  }

  const handleViewAllButton = () => {
    navigate("/revenue-dashboard");
  };

  return (
    <TotalCardWrapper>
      <GlobalStyles
        styles={{
          "*::-webkit-scrollbar": {
            width: "0.4em",
            height: "8px",
          },
          "*::-webkit-scrollbar-track": {
            WebkitBoxShadow: `inset 0 0 6px ${Colors.black}`,
            backgroundColor: Colors.primarygray_200,
            boxShadow: Colors.Elevation_2,
          },
          "*::-webkit-scrollbar-thumb": {
            backgroundColor: Colors.primarygray_400,
            outline: "1px solid slategrey",
            borderRadius: "4px",
            cursor: "pointer",
          },
        }}
      />
      <ParentCard handleViewAllButton={handleViewAllButton} title="Total Sales">
        <CurrentProgressMainWrapper onClick={handleViewAllButton}>
          <CurrentProgress
            current={cardData?.currentSales}
            target={cardData?.targetSales}
            percentage={cardData?.revenue_pct}
            eventName={cardData?.event_name}
            filter={filter}
            loading={loading}
          />
        </CurrentProgressMainWrapper>
        <TotalSalesSharedCardWrapper>
          {dataList?.map((i: MapDataListType, index: number) => {
            const lastCard = dataList.length - 1;
            return (
              <TotalSalesSharedCard
                index={index}
                lastCard={lastCard}
                key={i?.title}
                title={i?.title}
                listData={i?.list}
                icon={i?.icon}
                loading={loading}
              />
            );
          })}
        </TotalSalesSharedCardWrapper>
      </ParentCard>
    </TotalCardWrapper>
  );
};

export default TotalSales;
